import type { ApiClient } from '../client';

// Force a «Entrega» to rejected (the «Usuario» does not want the parcel). The id rides the path
// (url-encoded); the client attaches the Firebase token via the Authorization header. Empty 200 —
// nothing to parse; the caller refetches the detail to surface the new state and the «Recogida
// rechazada por el usuario» row.
export async function rejectDelivery(client: ApiClient, id: string): Promise<void> {
  await client.post(`/app_service/panel/v1/deliveries/${encodeURIComponent(id)}/reject`);
}
